import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContentPolicy from './components/ContentPolicy';
import TermsCondition from './components/TermsofService';
import Disclaimer from './components/Disclaimer';
import Contact from './components/Contact';
import About from './components/About'
import Home from './components/Home';
import Footer from './components/Footer';
import StockProfitCalculator from './components/Pages/StockProfitCalculator';
import ShortLongCalculator from './components/Pages/ShortLongCalculator';
import DividendProfitCalculator from './components/Pages/DividendProfitCalculator';
import SIPCalculator from './components/Pages/SIPCalculator';
import StockPortfolioCalculator from './components/Pages/StockPortfolioCalculator';
import RetirementInvestmentCalculator from './components/Pages/RetirementInvestmentCalculator';
import StopLossCalculator from './components/Pages/StopLossCalculator';
import RiskRewardCalculator from './components/Pages/RiskRewardCalculator';
import StopLossTargetCalculator from './components/Pages/StopLossTargetCalculator';
import StockCapitalGainsCalculator from './components/Pages/StockCapitalGainsCalculator';
import BrokerageCalculator from './components/Pages/BrokerageCalculator';
import DividendTaxCalculator from './components/Pages/DividendTaxCalculator';
import CookiePolicy from './components/CookiePolicy';
import AveragePriceCalculator from './components/Pages/AveragePriceCalculator';
import StockBreakevenCalculator from './components/Pages/StockBreakevenCalculator';
import TargetPriceCalculator from './components/Pages/TargetPriceCalculator';
import QuantityEstimatorCalculator from './components/Pages/QuantityEstimatorCalculator';
import MaxBuyCalculator from './components/Pages/MaxBuyCalculator';
import LotSizeFinderCalculator from './components/Pages/LotSizeFinderCalculator';
import LumpSumReturnsCalculator from './components/Pages/LumpSumReturnsCalculator';
import InflationImpactCalculator from './components/Pages/InflationImpactCalculator';
import GoalPlannerCalculator from './components/Pages/GoalPlannerCalculator';
import WealthProjectionCalculator from './components/Pages/WealthProjectionCalculator';
import RetirementGapFinderCalculator from './components/Pages/RetirementGapFinderCalculator';
import CompoundingVisualizerCalculator from './components/Pages/CompoundingVisualizerCalculator';
import PositionSizeCalculator from './components/Pages/PositionSizeCalculator';
import StockVolatilityRiskCalculator from './components/Pages/StockVolatilityRiskCalculator';
import MaxLossCalculator from './components/Pages/MaxLossCalculator';
import TradeRiskAnalyzer from './components/Pages/TradeRiskAnalyzer';
import RiskPerTradeFinder from './components/Pages/RiskPerTradeFinder';
import RiskExposureMeterCalculator from './components/Pages/RiskExposureMeterCalculator';
import TaxEstimatorCalculator from './components/Pages/TaxEstimatorCalculator';
import NetProfitAfterTaxCalculator from './components/Pages/NetProfitAfterTaxCalculator';
import PostTaxReturnCalculator from './components/Pages/PostTaxReturnCalculator';
import TaxBracketFinder from './components/Pages/TaxBracketFinder';
import EffectiveTaxRateCalculator from './components/Pages/EffectiveTaxRateCalculator';
import TaxDeductionsCalculator from './components/Pages/TaxDeductionsCalculator';
import WaldoAd from './components/AdComponent';

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Routes>
          <Route
  path="/"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Best Free Stock Market Calculators & Tools</title>
        <meta
          name="description"
          content="Access free online stock market calculators and tools to estimate profits, dividends, fees, ROI, and more. Perfect for traders and investors."
        />
        <meta
          name="keywords"
          content="stock calculators, investment calculators, trading fee calculator, dividend calculator, ROI calculator"
        />
      </Helmet>
      <Home />
    </>
  }
/>

<Route
  path="/StockProfitCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stock Profit Calculator</title>
        <meta
          name="description"
          content="Calculate your stock profits easily with NoobToBull's Stock Profit Calculator."
        />
        <meta
          name="keywords"
          content="stock profit calculator, trading calculator, investment profit calculator"
        />
      </Helmet>
      <StockProfitCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/ShortLongCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Short/Long Position Calculator</title>
        <meta
          name="description"
          content="Estimate gains or losses on short and long positions with NoobToBull's Short/Long Calculator."
        />
        <meta
          name="keywords"
          content="short long calculator, trading calculator, stock position calculator"
        />
      </Helmet>
      <ShortLongCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/DividendProfitCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Dividend Profit Calculator</title>
        <meta
          name="description"
          content="Easily calculate your dividend profits with NoobToBull's Dividend Profit Calculator."
        />
        <meta
          name="keywords"
          content="dividend calculator, investment profit calculator, stock dividend calculator"
        />
      </Helmet>
      <DividendProfitCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/SIPCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - SIP Calculator</title>
        <meta
          name="description"
          content="Plan your systematic investment with NoobToBull's SIP Calculator for stocks and mutual funds."
        />
        <meta
          name="keywords"
          content="SIP calculator, systematic investment, investment planning"
        />
      </Helmet>
      <SIPCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StockPortfolioCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stock Portfolio Calculator</title>
        <meta
          name="description"
          content="Track and calculate the performance of your stock portfolio with NoobToBull's Portfolio Calculator."
        />
        <meta
          name="keywords"
          content="stock portfolio calculator, investment tracking, portfolio performance"
        />
      </Helmet>
      <StockPortfolioCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/RetirementInvestmentCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Retirement Investment Calculator</title>
        <meta
          name="description"
          content="Plan your retirement investments and estimate returns with NoobToBull's Retirement Calculator."
        />
        <meta
          name="keywords"
          content="retirement calculator, investment planning, stock returns calculator"
        />
      </Helmet>
      <RetirementInvestmentCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StopLossCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stop Loss Calculator</title>
        <meta
          name="description"
          content="Set your stop loss levels and manage risks efficiently with NoobToBull's Stop Loss Calculator."
        />
        <meta
          name="keywords"
          content="stop loss calculator, trading risk management, stock stop loss"
        />
      </Helmet>
      <StopLossCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/RiskRewardCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Risk/Reward Calculator</title>
        <meta
          name="description"
          content="Evaluate potential gains versus losses for your trades using NoobToBull's Risk/Reward Calculator."
        />
        <meta
          name="keywords"
          content="risk reward calculator, stock trading, trade analysis"
        />
      </Helmet>
      <RiskRewardCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StopLossTargetCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stop Loss Target Calculator</title>
        <meta
          name="description"
          content="Calculate stop loss and target prices for trades efficiently with NoobToBull's Stop Loss Target Calculator."
        />
        <meta
          name="keywords"
          content="stop loss target calculator, trading calculator, stock targets"
        />
      </Helmet>
      <StopLossTargetCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StockCapitalGainsCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stock Capital Gains Calculator</title>
        <meta
          name="description"
          content="Estimate your capital gains and taxes on stock investments using NoobToBull's Stock Capital Gains Calculator."
        />
        <meta
          name="keywords"
          content="capital gains calculator, stock tax calculator, investment calculator"
        />
      </Helmet>
      <StockCapitalGainsCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/BrokerageCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Brokerage Calculator</title>
        <meta
          name="description"
          content="Calculate brokerage fees for your stock trades easily with NoobToBull's Brokerage Calculator."
        />
        <meta
          name="keywords"
          content="brokerage calculator, trading fees, stock trading calculator"
        />
      </Helmet>
      <BrokerageCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/DividendTaxCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Dividend Tax Calculator</title>
        <meta
          name="description"
          content="Calculate taxes on your stock dividends with NoobToBull's Dividend Tax Calculator."
        />
        <meta
          name="keywords"
          content="dividend tax calculator, stock tax calculator, investment tax"
        />
      </Helmet>
      <DividendTaxCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/Contact"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Contact Us</title>
        <meta
          name="description"
          content="Get in touch with NoobToBull for any queries or support regarding our stock market calculators and tools."
        />
        <meta
          name="keywords"
          content="contact, support, stock market tools, NoobToBull"
        />
      </Helmet>
      <Contact />
    </>
  }
/>

<Route
  path="/PrivacyPolicy"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Privacy Policy</title>
        <meta
          name="description"
          content="Read NoobToBull's Privacy Policy to understand how we handle your data and ensure your privacy."
        />
        <meta
          name="keywords"
          content="privacy policy, data protection, NoobToBull"
        />
      </Helmet>
      <PrivacyPolicy />
    </>
  }
/>

<Route
  path="/TermsCondition"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Terms & Conditions</title>
        <meta
          name="description"
          content="Read NoobToBull's Terms & Conditions for the proper use of our stock market tools and calculators."
        />
        <meta
          name="keywords"
          content="terms and conditions, NoobToBull, stock market tools"
        />
      </Helmet>
      <TermsCondition />
    </>
  }
/>

<Route
  path="/Disclaimer"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Disclaimer</title>
        <meta
          name="description"
          content="Read NoobToBull's Disclaimer regarding the use of our stock market calculators and tools."
        />
        <meta
          name="keywords"
          content="disclaimer, stock market tools, NoobToBull"
        />
      </Helmet>
      <Disclaimer />
    </>
  }
/>

<Route
  path="/ContentPolicy"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Content Policy</title>
        <meta
          name="description"
          content="Read NoobToBull's Content Policy to understand the rules for using our website and tools."
        />
        <meta
          name="keywords"
          content="content policy, NoobToBull, stock market tools"
        />
      </Helmet>
      <ContentPolicy />
    </>
  }
/>

<Route
  path="/About"
  element={
    <>
      <Helmet>
        <title>NoobToBull - About Us</title>
        <meta
          name="description"
          content="Learn more about NoobToBull, our mission, and how we provide free stock market calculators and tools for traders and investors."
        />
        <meta
          name="keywords"
          content="about us, NoobToBull, stock market tools, stock calculators"
        />
      </Helmet>
      <About />
    </>
  }
/>

<Route
  path="/CookiePolicy"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Cookie Policy</title>
        <meta
          name="description"
          content="Read the Cookie Policy of NoobToBull, detailing how we use cookies to improve user experience and provide personalized content."
        />
        <meta
          name="keywords"
          content="cookie policy, NoobToBull, cookies, website privacy"
        />
      </Helmet>
      <CookiePolicy />
    </>
  }
/>

<Route
  path="/AveragePriceCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Average Price Calculator</title>
        <meta
          name="description"
          content="Use the Average Price Calculator to find your adjusted stock price after multiple purchases."
        />
        <meta
          name="keywords"
          content="average price calculator, stock average calculator"
        />
      </Helmet>
      <AveragePriceCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StockBreakevenCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stock Breakeven Calculator</title>
        <meta
          name="description"
          content="Calculate the breakeven point for your stock trades using this simple tool."
        />
        <meta
          name="keywords"
          content="breakeven calculator, stock breakeven"
        />
      </Helmet>
      <StockBreakevenCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/TargetPriceCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Target Price Calculator</title>
        <meta
          name="description"
          content="Find the ideal target price to reach your profit goals when trading."
        />
        <meta
          name="keywords"
          content="target price calculator, stock target"
        />
      </Helmet>
      <TargetPriceCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/QuantityEstimatorCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Quantity Estimator</title>
        <meta
          name="description"
          content="Estimate how many shares you can buy based on your budget and stock price."
        />
        <meta
          name="keywords"
          content="stock quantity calculator, share estimator"
        />
      </Helmet>
      <QuantityEstimatorCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/MaxBuyCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Max Buy Calculator</title>
        <meta
          name="description"
          content="Calculate the maximum number of shares you can purchase with your available funds."
        />
        <meta
          name="keywords"
          content="max buy calculator, stock buy limit"
        />
      </Helmet>
      <MaxBuyCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/LotSizeFinderCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Lot Size Finder</title>
        <meta
          name="description"
          content="Quickly find the lot size for different stocks or financial instruments."
        />
        <meta
          name="keywords"
          content="lot size calculator, lot size finder"
        />
      </Helmet>
      <LotSizeFinderCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/LumpSumReturnsCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Lump Sum Returns Calculator</title>
        <meta
          name="description"
          content="Estimate potential returns on your lump sum investments."
        />
        <meta
          name="keywords"
          content="lump sum calculator, investment return"
        />
      </Helmet>
      <LumpSumReturnsCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/InflationImpactCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Inflation Impact Calculator</title>
        <meta
          name="description"
          content="Understand how inflation affects the future value of your money."
        />
        <meta
          name="keywords"
          content="inflation calculator, inflation impact"
        />
      </Helmet>
      <InflationImpactCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/GoalPlannerCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Goal Planner Calculator</title>
        <meta
          name="description"
          content="Plan your financial goals and estimate how much you need to save."
        />
        <meta
          name="keywords"
          content="goal planner, financial planning tool"
        />
      </Helmet>
      <GoalPlannerCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/WealthProjectionCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Wealth Projection Calculator</title>
        <meta
          name="description"
          content="Project your future wealth based on investments and savings."
        />
        <meta
          name="keywords"
          content="wealth projection, investment growth calculator"
        />
      </Helmet>
      <WealthProjectionCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/RetirementGapFinderCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Retirement Gap Finder</title>
        <meta
          name="description"
          content="Find the gap between your current savings and retirement goals."
        />
        <meta
          name="keywords"
          content="retirement gap, retirement calculator"
        />
      </Helmet>
      <RetirementGapFinderCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/CompoundingVisualizerCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Compounding Visualizer</title>
        <meta
          name="description"
          content="Visualize compound interest growth for your investments."
        />
        <meta
          name="keywords"
          content="compound interest calculator, compounding graph"
        />
      </Helmet>
      <CompoundingVisualizerCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/PositionSizeCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Position Size Calculator</title>
        <meta
          name="description"
          content="Calculate the ideal position size based on your risk level and account value."
        />
        <meta
          name="keywords"
          content="position size, risk management calculator"
        />
      </Helmet>
      <PositionSizeCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/StockVolatilityRiskCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Stock Volatility Risk Calculator</title>
        <meta
          name="description"
          content="Measure stock volatility and assess risk before making trades."
        />
        <meta
          name="keywords"
          content="volatility calculator, stock risk"
        />
      </Helmet>
      <StockVolatilityRiskCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/MaxLossCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Max Loss Calculator</title>
        <meta
          name="description"
          content="Estimate the maximum possible loss for your trades based on stop loss levels."
        />
        <meta
          name="keywords"
          content="max loss calculator, trade risk"
        />
      </Helmet>
      <MaxLossCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/TradeRiskAnalyzer"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Trade Risk Analyzer</title>
        <meta
          name="description"
          content="Analyze the risk level of your trades and improve decision making."
        />
        <meta
          name="keywords"
          content="trade risk analyzer, trading tool"
        />
      </Helmet>
      <TradeRiskAnalyzer />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/RiskPerTradeFinder"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Risk Per Trade Finder</title>
        <meta
          name="description"
          content="Find the amount you should risk per trade based on your trading plan."
        />
        <meta
          name="keywords"
          content="risk per trade, trading risk calculator"
        />
      </Helmet>
      <RiskPerTradeFinder />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/RiskExposureMeterCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Risk Exposure Meter</title>
        <meta
          name="description"
          content="Measure your overall risk exposure across different trades."
        />
        <meta
          name="keywords"
          content="risk meter, exposure calculator"
        />
      </Helmet>
      <RiskExposureMeterCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/TaxEstimatorCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Tax Estimator Calculator</title>
        <meta
          name="description"
          content="Estimate your taxes on profits and investments."
        />
        <meta
          name="keywords"
          content="tax estimator, tax calculator"
        />
      </Helmet>
      <TaxEstimatorCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/NetProfitAfterTaxCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Net Profit After Tax Calculator</title>
        <meta
          name="description"
          content="Calculate your net profit after taxes are applied."
        />
        <meta
          name="keywords"
          content="net profit after tax, profit calculator"
        />
      </Helmet>
      <NetProfitAfterTaxCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/PostTaxReturnCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Post Tax Return Calculator</title>
        <meta
          name="description"
          content="Find out how much your return is after taxes are deducted."
        />
        <meta
          name="keywords"
          content="post tax return, investment tax"
        />
      </Helmet>
      <PostTaxReturnCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/TaxBracketFinder"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Tax Bracket Finder</title>
        <meta
          name="description"
          content="Identify which tax bracket you fall into based on your income."
        />
        <meta
          name="keywords"
          content="tax bracket finder, income tax"
        />
      </Helmet>
      <TaxBracketFinder />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/EffectiveTaxRateCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Effective Tax Rate Calculator</title>
        <meta
          name="description"
          content="Calculate your effective tax rate after deductions and adjustments."
        />
        <meta
          name="keywords"
          content="effective tax rate, tax calculator"
        />
      </Helmet>
      <EffectiveTaxRateCalculator />
      <WaldoAd />
    </>
  }
/>

<Route
  path="/TaxDeductionsCalculator"
  element={
    <>
      <Helmet>
        <title>NoobToBull - Tax Deductions Calculator</title>
        <meta
          name="description"
          content="Estimate how much you can reduce your taxes through deductions."
        />
        <meta
          name="keywords"
          content="tax deductions, tax saving calculator"
        />
      </Helmet>
      <TaxDeductionsCalculator />
      <WaldoAd />
    </>
  }
/>


          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;